// extracted by mini-css-extract-plugin
export default {"mainButton":"ShopLink_mainButton__+c8kS"};